import React from "react";

interface Props {
  settings: any;
  setSettings: any;
}
const AppointmentCalendar = (props: Props) => {
  const {} = props;
  return <></>;
};

export default AppointmentCalendar;
